import { Suspense } from "react";
import { Outlet } from "react-router";
import ScrollToTop from "./ScrollToTop";
import AnalyticsTracker from "./AnalyticsTracker";

export default function LayoutWrapper() {
  return (
    <>
      <AnalyticsTracker />
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-purple-50">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600"></div>
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
}
